import "./FooterSection.scss";

function FooterSection() {
  return (
    <footer className="footer">
      <p> &copy; inStock Inc. All Rights Reserved.</p>
    </footer>
  );
}

export default FooterSection;
